/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AuthContactMagicLinkLoginResponseDataVisitorFromJSON, AuthContactMagicLinkLoginResponseDataVisitorToJSON } from './AuthContactMagicLinkLoginResponseDataVisitor';
export function AuthContactMagicLinkLoginResponseDataFromJSON(json) {
    return AuthContactMagicLinkLoginResponseDataFromJSONTyped(json, false);
}
export function AuthContactMagicLinkLoginResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        visitor: !exists(json, 'visitor')
            ? undefined
            : AuthContactMagicLinkLoginResponseDataVisitorFromJSON(json['visitor'])
    };
}
export function AuthContactMagicLinkLoginResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        visitor: AuthContactMagicLinkLoginResponseDataVisitorToJSON(value.visitor)
    };
}
